enum SFDCMode {
    home = 'home',
    source = 'source',
    target = 'target',
    source_callback = 'oauth2_source_callback',
    target_callback = 'oauth2_target_callback',
}

export default SFDCMode;
